import { NavLink } from "react-router-dom";

interface MenuItem {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
  badgeKey?: "messages" | "changes";
}

const MENU_ITEMS: MenuItem[] = [
  { to: "/dashboard", label: "Inicio", icon: "📊", end: true },
  { to: "/dashboard/projects", label: "Mis Proyectos", icon: "📋" },
  { to: "/dashboard/models", label: "Modelos 3D", icon: "🎨" },
  { to: "/dashboard/advances", label: "Avances", icon: "📈" },
  { to: "/dashboard/changes", label: "Cambios", icon: "🔄", badgeKey: "changes" },
  { to: "/dashboard/payments", label: "Estado de Cuenta", icon: "💳" },
  { to: "/dashboard/documents", label: "Documentos", icon: "📄" },
  { to: "/dashboard/messages", label: "Mensajes", icon: "💬", badgeKey: "messages" },
  { to: "/dashboard/tokens", label: "Tokens", icon: "💎" },
  { to: "/dashboard/settings", label: "Configuración", icon: "⚙️" },
];

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  unreadMessages?: number;
  pendingChangeOrders?: number;
}

export function Sidebar({
  isOpen,
  onClose,
  unreadMessages = 0,
  pendingChangeOrders = 0,
}: SidebarProps) {
  const getBadge = (item: MenuItem): number => {
    if (item.badgeKey === "messages") return unreadMessages;
    if (item.badgeKey === "changes") return pendingChangeOrders;
    return 0;
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      <aside
        className={`fixed lg:sticky lg:top-0 lg:h-screen inset-y-0 left-0 z-50 w-64 bg-white border-r border-slate-200 flex flex-col transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <div className="p-5 border-b border-slate-200 flex items-center justify-between">
          <img src="/img/logo.png" alt="Gran Arquitectura" className="h-10" />
          <button
            onClick={onClose}
            className="lg:hidden text-slate-400 hover:text-slate-700 text-xl"
            aria-label="Cerrar menú"
          >
            ×
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto p-3">
          <ul className="space-y-1">
            {MENU_ITEMS.map((item) => {
              const badge = getBadge(item);
              return (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    onClick={onClose}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                        isActive
                          ? "bg-primary-light text-primary"
                          : "text-slate-700 hover:bg-slate-100"
                      }`
                    }
                  >
                    <span className="text-lg w-5 text-center">{item.icon}</span>
                    <span className="flex-1">{item.label}</span>
                    {badge > 0 && (
                      <span className="bg-primary text-white text-xs font-bold rounded-full px-2 py-0.5 min-w-[20px] text-center">
                        {badge > 99 ? "99+" : badge}
                      </span>
                    )}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="p-4 border-t border-slate-200 text-xs text-slate-400 text-center">
          © 2026 Gran Arquitectura
        </div>
      </aside>
    </>
  );
}